import select from './select.vue'

select.install = (VueInstance) => {
  VueInstance.component('c-select', select)
}

export default select
